import './melbournegroup2/style';
import FormStructure from './melbournegroup2/form_structure';

export default FormStructure;